import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { getBannerLoading } from "../../../../Redux/BannerLoading/BannerLoadingSlice";
import { log } from "video.js";
import Translate from "../../../../Components/Multilanguage/Translate";
import BannerUtil from "../util.jsx";
import { imageUrlCheck } from "../../../../utils/utils";
import playButton from "../../../../assets/Images/play.png"
const SwiperItem = ({ data }) => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const dispatch = useDispatch()
  const [isImageLoad, setIsImageLoad] = useState(false);
  const buttonTextColor = projectInfo?.projectConfig?.config?.BUTTON_TEXT_COLOR ;
  const textColor = projectInfo?.projectConfig?.config?.TEXT_COLOR; 
  const theme = projectInfo?.projectConfig?.config?.THEME;
  const template = projectInfo?.projectConfig?.config?.TEMPLATE;
  const navigate = useNavigate();
  const { afterImageLoad, replaceImage, playClickHandler } = BannerUtil();

  useEffect(()=>{
    return ()=>{
      dispatch(
        getBannerLoading({
          bannerLoading:false
        })
      )
    }
  },[])


  return (
    <div className={!isImageLoad?"bannerContainer loading":"bannerContainer"}>
      <div className="fadeGradientBottom"></div> 
      <div className="left">
        <div className="contents">
          <h1 className={`title ${theme === "LIGHT" ? "light-theme-text" : ""} ${projectInfo?.projectConfig?.pubid === 50147 ? 'template-11-font' : template === 'TEMPLATE_9' ? 'template-9' : ''}`}>
            { (data?.image_title && imageUrlCheck(`${data.image_title}`)) ? (
                <img src={`${data.image_title}`} alt={data.image_title || data.show_name} className="titleImage" />
              ) : (
                data?.show_name
            )}
          </h1>
           <div className="genres">
              {projectInfo?.projectConfig?.pubid !== 50119 &&
               data?.categories
                ?.filter(item => item?.category_name)
                .map((item, index) => (
                  <span key={index}>{item.category_name}</span>
                ))
              }
           </div>
          {data?.synopsis && <p className="description">{data?.synopsis}</p>}
          <span className="duration">{data?.duration_text}</span>
          <div className="buttonsWrapper">
            <div className="buttonContainer" onClick={() => playClickHandler(data)}>
              { projectInfo?.projectConfig?.pubid === 50147 ? (
                <img src={playButton} alt="Play" className="playButton" />
              ) : (
                <>
                  <div className="background"></div>
                  <button className={`watchNowButton ${theme === "LIGHT" ? 'light-theme-button' : ''}`}style={{ color: projectInfo?.projectConfig?.config?.TEMPLATE === 'TEMPLATE_9' ? buttonTextColor : textColor }}>
                    <Translate textKey={'watch_now'}/>
                  </button>
                </>
              )}
            </div>           
            {data?.show_trailer && <div className="buttonContainer" onClick={() => playClickHandler({...data, teaser_vanity_url: data.show_trailer})}>
              <div className="Trailerbackground background"></div>
              <button className="trailerButton"><Translate textKey={'trailer'}/></button>
            </div>}
          </div>
        </div>
      </div>
      <div className="right">
        <div className="fadeGradient"></div>
        <div className={"imageContainer"}>
          {imageUrlCheck(data?.banner) ? (
            <img src={data?.banner} 
                 onError={(e) => replaceImage(e)} 
                 onLoad={(e) => {
                   setIsImageLoad(true);
                   afterImageLoad();
                 }} 
                 alt="BgImage" />
          ) : (
            <img src={`${process.env.REACT_APP_IMAGE_URL}${data?.banner}`} 
                 onError={(e) => replaceImage(e)} 
                 alt="BgImage"  />
          )}
       
        </div>
      </div>
    </div>
  );
};

export default SwiperItem;